<template style="background-color:white">
  <section class="init_box" style="background-color:white;">
    <el-row type="flex" justify="end" style="flex-wrap: wrap; flex-direction: row">
      <el-col :span="24" style="margin-top: 15px; padding-left:10px">
        <el-button class="btn" size="small" type="primary" @click="addHandle">添加</el-button>
      </el-col>
    </el-row>
    <el-row style="margin-top:15px;flex-wrap: wrap; flex-direction: row" type="flex" justify="end">
      <el-col :span="5" style="float:left;margin-top:10px">
        <el-button type="primary" class="statueBtn" style="background-color:chocolate;"></el-button><span
          class="statueSpan" style="">结束</span>
        <el-button type="primary" class="statueBtn" style="background-color:green;"></el-button><span class="statueSpan"
          style="">正常</span>
      </el-col>
      <!-- 搜索框 -->
      <el-col :span="19">
        <el-form :model="searchModel" :inline="true" style="float:right" @submit.native.prevent>
          <el-form-item label="模糊搜索">
            <el-input placeholder="请输入查询项目名称、地址" auto-complete="off" prefix-icon="el-icon-search"
              @keyup.enter.native="getList" v-model="searchModel.search" style="width:100%;margin-right: 55px;"
              clearable>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" style="" size="small" @click="getList">搜索</el-button>
          </el-form-item>
        </el-form>
      </el-col>
      <!-- 筛选框按钮，可筛选显示的列 -->
      <el-col :span="24" style="float:left;">
        <!-- <el-button style="float: right;margin-right: 15px;" icon="iconfont icon-liebiao"></el-button> -->
        <el-dropdown :hide-on-click="false" style="float:right;margin-right:15px">
          <i class="iconfont icon-liebiao"></i>
          <el-dropdown-menu slot="dropdown">
            <el-scrollbar style="height: 60vh"><!--作用是数据过多把表单数据的整体高度固定、多出的区域可以下拉展示-->
              <el-checkbox-group v-model="check">
                <el-dropdown-item v-for="(item, index) in checkList" :key="index">
                  <el-checkbox :label="item" :key="item"> </el-checkbox>
                </el-dropdown-item>
              </el-checkbox-group>
            </el-scrollbar>
          </el-dropdown-menu>
        </el-dropdown>
      </el-col>
      <!-- 数据展示表格 -->
      <el-col :span="24" style="margin-top:5px">
        <el-table :data="dataList" ref="infoTable" id="infoTable" :header-cell-style="{ background: '#eff3f6' }" stripe
          :row-key="getRowKeys"
          style="width: 99%;margin: 0px auto ;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;"
          height="600">
          <el-table-column type="selection" width="55" :reserve-selection="true" style="border-color: black;">
          </el-table-column>
          <el-table-column type="index" label="序号" width="80">
            <template slot-scope="scope">
              <span>{{ scope.$index + (pageIndex - 1) * pageSize + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="projectName" label="项目名称" width="300" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="addressName" label="所属区域" width="300" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="addressDetail" label="详细地址" :show-overflow-tooltip="true"
            align="left"></el-table-column>
          <el-table-column prop="addressCoordinate" label="坐标" width="200"
            :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="status" label="状态" width="120" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.status == 1" style="color:green;">正常</span>
              <span v-else style="color:chocolate;">结束</span>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" width="180"></el-table-column>
          <el-table-column label="操作" width="80">
            <template slot-scope="scope">
              <el-button @click="editHandle(scope.row)" type="text" size="small">
                修改
              </el-button>
            </template>
          </el-table-column>

        </el-table>
      </el-col>
      <!--分页工具条-->
      <el-col :span="24" class="toolbar" style="margin-top:5px;height: 35px;">
        <el-pagination v-if="total > 0" @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :current-page="pageIndex"
          layout="total, sizes, prev, pager, next, jumper" :total="total" style="float:right">
        </el-pagination>
      </el-col>
    </el-row>
    <!-- 添加显示购物车按钮，如果复选框有选中让显示，否则不显示 -->
    <div style="position:fixed;top:18%;left:600px;height: 50px;width: 50px;font-size: 20px;"
      @click="checkBoxdialog = true" v-if="checkBoxData.length > 0">
      <!-- <i class="iconfont icon-icon-test" style="width:100%;height:100%;font-size: 40px;"></i> -->
      <el-badge :value="checkBoxNumber">
        <!-- <span class="iconfont icon--task- " style="width:100%;height:100%;font-size: 40px"></span> -->
        <img src="../../../static/img/selects.png" style="width:70%;height:70%;font-size: 40px;" />
      </el-badge>
    </div>

    <!-- 添加 -->
    <el-dialog :visible.sync="addShow" title="添加项目" :close-on-click-modal="false" :close-on-press-escape="false"
      width="700px">
      <el-form :model="addForm" ref="addForm" :rules="addRules" label-position="left" label-width="100px"
        style="width: 90%; margin-left:5%;">
        <el-row>
          <el-col :span="24" align="left">
            <el-form-item label="项目名称" prop="projectName">
              <el-input v-model.trim="addForm.projectName" placeholder="请输入项目名称" />
            </el-form-item>
          </el-col>

        </el-row>
        <el-row>
          <el-col :span="24" align="left">
            <el-form-item label="所属区域" prop="addressIds">
              <el-cascader style="width: 100%" ref="cascader" class="cascader" v-if="addressPro"
                v-model="addForm.addressIds" :props="propsAddress" @change="handleCascaderChange"
                :placeholder="addressPro" />
              <el-cascader style="width: 100%" v-else ref="cascader" v-model="addForm.addressIds" :props="propsAddress"
                @change="handleCascaderChange" placeholder="选择所属地域" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" align="left">
            <el-form-item label="详细地址" prop="addressDetail">
              <el-input placeholder="请输入详细地址" v-model.trim="addForm.addressDetail"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" align="left">
            <el-form-item label="地图坐标" prop="addressCoordinate">
              <el-input placeholder="请选择地图坐标" v-model.trim="addForm.addressCoordinate" :readonly="true">
                <el-button icon="el-icon-search" slot="append" circle @click="selectAddressHandle"></el-button>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12" align="left">
            <el-form-item label="项目状态" prop="status">
              <el-select v-model="addForm.status" placeholder="请选择项目状态" style="width: 100%">
                <el-option label="正常" :value="1"></el-option>
                <el-option label="结束" :value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div slot="footer" class="dialog-footer" style="text-align: center;">
        <el-button style="margin-left: 10px;" type="info" @click="addShow = false">关闭</el-button>
        <el-button style="margin-left: 10px;" type="primary" @click="addOk">提交</el-button>
      </div>
    </el-dialog>

    <!-- 添加 -->
    <el-dialog :visible.sync="selectAddressShow" title="选择位置" :close-on-click-modal="false"
      :close-on-press-escape="false" width="60%">
      <el-row>
        <TdMap :currNode="currNode" @selectAddressOk="selectAddressOk"></TdMap>
      </el-row>
    </el-dialog>

  </section>
</template>
<script>
import {
  mktProjectList,
  selectArea,
  mktProjectAdd,
  mktProjectView
} from "../../api/api";
import TdMap from "./components/TdMap.vue"
export default {
  name: "project",
  components: {
    TdMap
  },
  data() {
    return {
      companyProps: {
        checkStrictly: true,
        label: "companyName",
        value: "companyCode",
        children: "zcompany",
        emitPath: false
      },
      propsAddress: {
        lazy: true,
        lazyLoad(node, resolve) {
          const { value } = node;
          let nodes = [];
          selectArea({ pid: value ? value : 0 }).then(datas => {
            let { status, data } = datas;
            if (status == 200) {
              data.forEach(item => {
                nodes.push({
                  label: item.name,
                  value: item.id,
                  leaf: item.deep == 2 ? true : false,
                  latitude: item.latitude,
                  longitude: item.longitude,
                  extPath: item.extPath
                });
              });
            }
            resolve(nodes);
          })
        }
      },
      total: 0,
      pageIndex: 1,
      pageSize: 10,
      dataList: [],
      checkList: [],
      btnRole: [],
      searchModel: {
        projectName: "",
        addressDetail: ""
      },
      companySelect: [],
      deviceTypeSelect: [],
      check: [],
      checkList: [],
      checkBoxData: [],
      addressPro: null,
      addShow: false,
      addForm: {
        addressCoordinate: ''
      },
      addRules: {
        projectName: [{ required: true, message: "请输入项目名称", trigger: "blur" }],
        addressIds: [{ required: true, message: "请选择所属地区", trigger: "blur" }],
        addressDetail: [{ required: true, message: "请输入详细地址", trigger: "blur" }],
        addressCoordinate: [{ required: true, message: "请选择地图位置", trigger: "change" }]
        // addressCoordinate: [{ validator: (rule, value, callback) => {
        //   if (!value) {
        //     callback(new Error('请选择地图位置'));
        //   } else {
        //     callback();
        //   }
        // }, trigger: 'blur'}]
      },
      selectAddressShow: false,
      currNode: {}
    };
  },
  methods: {
    getList() {
      let pageIndex = this.pageIndex;
      let pageSize = this.pageSize;
      mktProjectList({ pageIndex, pageSize, ...this.searchModel }).then(datas => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.dataList = data.list;
          this.total = data.total;
        } else {
          this.$message({
            message: message,
            type: "error"
          });
        }
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageIndex = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getList();
    },
    selectAddressHandle() {
      if (!this.addForm.addressIds) {
        this.$message({
          message: '请先选择所属区域',
          type: "error"
        });
        return;
      }
      this.currNode = this.$refs.cascader.getCheckedNodes();
      this.selectAddressShow = true
    },
    selectAddressOk(lat_long) {
      this.$nextTick(() => {
        this.addForm.addressCoordinate = lat_long
      })
      this.selectAddressShow = false
    },
    //隐藏地址选择下拉
    handleCascaderChange(e) {
      this.$refs.cascader.dropDownVisible = false;
      this.currNode = this.$refs.cascader.getCheckedNodes();
      this.$nextTick(() => {
        this.addForm.addressCoordinate = ''
      })
    },
    getView(row) {
      mktProjectView({ id: row.id }).then(datas => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.viewForm = data;
        }
      })
    },
    getRowKeys(row) {
      return row.id;
    },
    editHandle(row) {
      mktProjectView({ id: row.id }).then(datas => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.addForm = data;
          this.addForm.status = Number(data.status);
          this.addressPro = data.addressName;
          this.addForm.addressIds = [0, 0, data.addressId];
          this.addShow = true
        }
      })
    },
    addHandle() {
      this.addForm = {
        addressCoordinate: '',
        status: 1
      };
      this.addressPro = null;
      this.addShow = true
    },
    resetData() {
      this.$nextTick(() => {
        this.addForm = {};
        this.addressPro = null
      })
    },
    addOk() {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          mktProjectAdd(this.addForm).then(datas => {
            let { status, message } = datas;
            if (status == 200) {
              this.$message({
                message: message,
                type: "success"
              });
              this.addShow = false
              this.resetData()
              this.getList()
            } else {
              this.$message({
                message: message,
                type: "error"
              });
            }
          })
        } else {
          console.log('验证失败!');
          return false;
        }
      });
    },
  },
  created() {
    this.getList();
  }
};
</script>
<style scoped>
.btn {
  float: left;
}

.statueBtn {
  padding: 10px 10px;
  border: 0px;
  float: left;
  margin-left: 10px;
}

.statueSpan {
  vertical-align: middle;
  float: left;
  margin-left: 5px;
}

/* .el-input__inner{
    height:40px!important
} */
</style>
<style>
.el-checkbox__inner {
  border: 1px solid #606266 !important;
}

.el-table__body-wrapper::-webkit-scrollbar {
  width: 12px !important;
  height: 12px !important;
}

.el-table__body-wrapper::-webkit-scrollbar-track {
  border-radius: 10px;
  background: #ededed;
}

.el-table__body-wrapper::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: #cfcbcb;
}
</style>
<style lang="less" scoped>
#deviceTable {
  /deep/ .el-table__body-wrapper::-webkit-scrollbar {
    width: 10px;
    /*滚动条宽度*/
    height: 15px;
    /*滚动条高度*/
    margin-top: 100px;
  }

  /* 给固定列设置下边距 */
  /deep/ .el-table__fixed {
    height: auto !important;
    bottom: 15px !important;
    /* 具体值是多少根据你横向滚动条的高度进行设置 */
  }

  /deep/ .el-table__fixed-left {
    height: 100% !important;
  }

  /* 去掉固定列下方的横线 */
  /deep/ .el-table__fixed::before,
  .el-table__fixed-left::before {
    display: none;
  }

  /*定义滚动条轨道 内阴影+圆角*/
  /deep/ .el-table__body-wrapper::-webkit-scrollbar-track {
    border-radius: 10px;
    background: #ededed;
  }

  /*定义滑块 内阴影+圆角*/
  /deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: #cfcbcb;
  }

  /deep/ .el-table__fixed-body-wrapper {
    height: calc(100% -57px) !important;
    padding-bottom: 17px;
    box-sizing: content-box;
  }

  /deep/ .tr-diaobo {
    color: red !important;
  }

  /deep/ .tr-baofei {
    color: #580fda !important;
  }

  /deep/ .tr-jiandin {
    color: #f4de5c !important;
  }
}

.el-table--border {
  border-color: #000000 !important;
  width: 320px;
  border-right: 1px solid #000000 !important;
  border-bottom: 1px solid #000000 !important;
}

.bm-view {
  width: 100%;
  height: 300px;
}

#table /deep/ .cell {
  padding-left: 2px !important;
  padding-right: 0px !important;
}

.docx-wrapper {
  background: white !important;
  padding: 10px;
}

.docx {
  padding: 0pt 20.65pt 20pt 20.55pt !important;
  width: 789.9pt !important;
  min-height: 0px !important;
  margin-top: -30px !important;
  margin-left: -10px !important;
}

/deep/ .cascader .el-input .el-input__inner::placeholder {
  color: #606266;
}
</style>



// WEBPACK FOOTER //
// src/views/market/Project.vue